import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/down-arrow.svg'


const _hoisted_1 = { class: "nav-menu__wrapper" }
const _hoisted_2 = { class: "alt" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "items" }

import { ref } from "vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from "@/i18n";
import { setI18nLanguage } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavAltMenu',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

let isSubMenu1Open = ref(false);
let isSubMenu2Open = ref(false);

const emit = __emit;

let localeStr: string = i18n.global.locale;

function switchLocale(locale: string) {
  setI18nLanguage(i18n, locale);
  localeStr = i18n.global.locale;

  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(isSubMenu2Open) //@ts-ignore
 ? isSubMenu2Open.value = !_unref(isSubMenu2Open) : isSubMenu2Open = !_unref(isSubMenu2Open))),
        class: _normalizeClass([{ active: _unref(isSubMenu2Open) }, "language-select sub-menu"]),
        "aria-label": "Switch locales"
      }, [
        _createElementVNode("p", null, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_unref(localeStr)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (switchLocale('en'))),
            "aria-label": "Change locale to english"
          }, " EN "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (switchLocale('pt'))),
            "aria-label": "Change locale to portuguese"
          }, " PT ")
        ])
      ], 2)
    ])
  ]))
}
}

})